export default "__VITE_ASSET__3d359648__"